/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tangy_Equal_Jellyfish_BorrowInputs */

const fr_tangy_equal_jellyfish_borrow = /** @type {(inputs: Tangy_Equal_Jellyfish_BorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance bras !`)
};

/**

* @param {Tangy_Equal_Jellyfish_BorrowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tangy_equal_jellyfish_borrow = /** @type {((inputs?: Tangy_Equal_Jellyfish_BorrowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tangy_Equal_Jellyfish_BorrowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tangy_equal_jellyfish_borrow(inputs)
});